export const useStoryblokLanguage = () => {
	const config = useRuntimeConfig();
	const { localeProperties } = useI18n();

	return computed(() => {
		const localeMap = config.public.storyblokLocaleMap as
			| Record<string, string>
			| undefined;
		const override = localeMap?.[localeProperties.value.code];
		if (override) return override;

		const mode = config.public.storyblokLanguageCode ?? "iso";

		if (mode === "code") {
			return localeProperties.value.code || localeProperties.value.iso;
		}

		return localeProperties.value.iso || localeProperties.value.code;
	});
};
